import type { ReactNode } from "react"
import * as React from "react"

import { Box, Text } from "@chakra-ui/react"

type Props = {
  children: ReactNode
  selected?: boolean
  onClick: () => void
}

const boxProps = {
  borderRadius: "sm",
  py: 1,
  px: 2,
}

const textProps: Partial<React.ComponentProps<typeof Text>> = {
  fontSize: 14,
  lineHeight: 1.1,
  color: "neutrals.900",
  userSelect: "none",
}

const activeProps = {
  fontWeight: 600,
  color: "#FFFFFF",
  bg: "primary.400",
}

export function PagingNumberItem({ children, onClick, selected }: Props) {
  return selected ? (
    <Box
      {...boxProps}
      {...textProps}
      {...activeProps}
      data-testid="pagingNumberItemActive"
    >
      {children}
    </Box>
  ) : (
    <Text
      {...boxProps}
      {...textProps}
      transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
      _hover={{
        ...activeProps,
        fontWeight: 400,
      }}
      cursor="pointer"
      onClick={onClick}
      data-testid="pagingNumberItem"
    >
      {children}
    </Text>
  )
}

export const Ellipsis = <Text {...textProps}>...</Text>
